import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';

export const FINANCIAL_PRODUCT_FILTERS_UPDATED = gql`
  subscription financialProductFiltersUpdated($productId: Int!) {
    financialProductFiltersUpdated(productId: $productId) {
      productId
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
